import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocReportsUnsubscribeRoute } from '@jira/router-routes__eoc-reports-routes/src/eocReportsUnsubscribeRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	LazyOpsReportsUnsubscribe,
	OpsReportsUnsubscribe,
} from './ui/spa/eoc/ops-reports/index.tsx';

export const eocReportsUnsubscribeRouteEntry: Route = createEntry(
	eocReportsUnsubscribeRoute,
	() => ({
		group: 'eoc',
		// eslint-disable-next-line no-restricted-syntax
		component: OpsReportsUnsubscribe,
		layout: opsTeamLayout,
		resources: [...getNavigationResources()],

		navigation: {
			menuId: MenuIdPeople,
		},

		forPaint: [LazyAtlassianNavigation, LazyOpsReportsUnsubscribe],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
